import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    YES, VIEW, EDIT, PENDING, IN_PROGRESS, SUPPOSEDLY_COMPLETED, COMPLETED, DEFERRED,
} from "const"
import {
    TaskStatusType,
    deepCopy,
} from "client/utils"
import {
    StoreType,
    TaskList,
    LoadTaskById,
    GetTaskAccess,
    UpdateTaskStatus,
    setTaskList,
    setTaskPopupMenuShow,
    addModal,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import DelegateUsers from "../view/delegateUsers"

// check conditions from view page
const Menu = () => {
    const baseRoute = useSelector((state: StoreType) => state.task.baseRoute)
    const taskList = useSelector((state: StoreType) => state.task.taskList)
    const activeTask = useSelector((state: StoreType) => state.task.active)
    const menuShow = useSelector((state: StoreType) => state.task.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.task.menuTarget)

    const taskParticipantList = useSelector((state: StoreType) => state.taskParticipant.taskParticipantList)
    const taskObserverList = useSelector((state: StoreType) => state.taskObserver.taskObserverList)

    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const { subTaskModuleAccess } = packageSettings

    const hideMenu = () => {
        dispatch(setTaskPopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const updateStatus = (status: TaskStatusType) => {
        UpdateTaskStatus(activeTask.id, status).then(() => {
            LoadTaskById(activeTask.id, userData.accountId).then((res) => {
                const taskListCopy: TaskList = taskList ? deepCopy(taskList) : {}
                taskListCopy[activeTask.id] = res
                dispatch(setTaskList(taskListCopy))
            })
        })
    }

    const {
        isCreator,
        isResponsible,
        isParticipant,

        addAccess,
        allowedToEdit,
    } = GetTaskAccess(activeTask, taskParticipantList, taskObserverList, userData)

    if (!activeTask) return null

    const viewUrl = `${baseRoute}/${VIEW}/${activeTask.id}`
    const editUrl = `${baseRoute}/${EDIT}/${activeTask.id}`
    const addUrl = `${baseRoute}/${EDIT}/0?parentId=${activeTask.id}`

    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            <PopupMenuItem onClick={() => dispatch(addModal({ url: viewUrl }))}>
                {lang.view}
            </PopupMenuItem>
            {
                allowedToEdit && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: editUrl }))}>
                        {lang.edit}
                    </PopupMenuItem>
                )
            }
            {
                addAccess && subTaskModuleAccess === YES && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: addUrl }))}>
                        {lang.createSubtask}
                    </PopupMenuItem>
                )
            }
            {
                (isResponsible || isParticipant || isCreator || allowedToEdit)
                && activeTask.status !== COMPLETED // includes: PENDING, IN_PROGRESS, DEFERRED, SUPPOSEDLY_COMPLETED
                && (
                    <PopupMenuItem onClick={() => {
                        if (isCreator) updateStatus(COMPLETED)
                        else if (isResponsible || isParticipant || allowedToEdit) updateStatus(SUPPOSEDLY_COMPLETED)
                    }}
                    >
                        {lang.complete}
                    </PopupMenuItem>
                )
            }
            {
                (isResponsible || isParticipant || isCreator || allowedToEdit) && (
                    <PopupMenuItem onClick={() => dispatch(addModal({
                        key: "delegate",
                        content: <DelegateUsers title={lang.delegateTo} task={activeTask} />,
                    }))}
                    >
                        {lang.delegate}
                    </PopupMenuItem>
                )
            }
            {
                (isResponsible || isParticipant || isCreator || allowedToEdit)
                && [PENDING, IN_PROGRESS].includes(activeTask ? activeTask.status : null)
                && (
                    <PopupMenuItem onClick={() => updateStatus(DEFERRED)}>
                        {lang.defer}
                    </PopupMenuItem>
                )
            }
            {
                (isResponsible || isParticipant || isCreator || allowedToEdit)
                && [DEFERRED, SUPPOSEDLY_COMPLETED, COMPLETED].includes(activeTask ? activeTask.status : null)
                && (
                    <PopupMenuItem onClick={() => updateStatus(PENDING)}>
                        {lang.resume}
                    </PopupMenuItem>
                )
            }
        </PopupMenu>
    )
}

export default Menu
